export default {
	"Testing":"Testen",
	"Management":"Management",
	"Support":"Support",
	"Data Quality":"Datenqualität",
	"No new notifications":"Keine Nachrichten",
	"Team Progress":"Team Fortschritt",
	"Add a task":"Aufgabe hinzuаügen",
	"Click to search a task":"Klicken Sie, um nach einer Aufgabe zu suchen",
	"Open the list of all tasks":"Öffnen Sie die Liste aller Aufgaben",
	"View the latest notifications":"Sehen Sie sich die neuesten Benachrichtigungen an",
	"Change your personal settings":"Ändern Sie Ihre persönlichen Einstellungen",
	"Pick your side of the Force":"Wähle deine Seite der Macht",
	"Dark":"Dunkle",
	"Light":"Helle",
	"Pick a language":"Wähle eine Sprache",
	"Latest tasks in your projects":"Neueste Aufgaben in Ihren Projekten",
	"Top margin in a popup window is smaller than the...":"Der obere Rand in einem Popup-Fenster ist kleiner als der...",
	"Autocat report":"Autocat Bericht",
	"Navigations problem in the left menu":"Navigationsprobleme im linken Menü",
	"Assignment":"Zuordnung",
	"Gita Noda assigned you a new ticket":"Gita Noda hat Ihnen ein neues Ticket zugewiesen",
	"Lorena Rush added new tasks":"Lorena Rush fügte neue Aufgaben hinzu",
	"'Confirm' button styling":"'Bestätigen' Knopf-Styling",
	"Cubebeat report":"Cubebeat Bericht",
	"No ability to exit profile editing dialogue":"Keine Möglichkeit, den Dialog zur Profilbearbeitung zu verlassen",
	"See all notifications":"Alle Benachrichtigungen anzeigen",
	"Persons":"Personen",
	"Click to sort":"Klicken Sie, um zu sortieren",
	"Total tasks completed":"Gesamtzahl der abgeschlossenen Aufgaben",
	"Hours spent, %":"Stunden verbracht, %",
	"Individual employee's progress":"Fortschritt des einzelnen Mitarbeiters",
	"Total tasks by projects":"Gesamtaufgaben nach Projekten",
	"incomplete":"unvollständig",
	"Tasks":"Aufgaben",
	"Meeting":"Treffen",
	"Mail":"E-Mail",
	"Calls":"Anrufe",
	"Button text on mobile devices":"Schaltflächentext auf mobilen Geräten",
	"Search pattern is ambiguous":"Suchmuster ist mehrdeutig",
	"Links in the upper right menu":"Enlaces en el menú superior derecho",
	"Menu thumbnails disappear when I click them":"Las miniaturas del menú desaparecen cuando hago clic en ellas",
	"Document export is empty":"La exportación del documento está vacía",
	"Button text in the right menu":"Schaltflächentext im rechten Menü",
	"Search is not working properly":"Die Suche funktioniert nicht richtig",
	"How do I define which column the sort was activated from?":"Wie definiere ich, aus welcher Spalte die Sortierung aktiviert wurde?",
	"How to apply fewer options of drop down menu for specific rows of datatable?":"Wie man weniger Optionen des Dropdown-Menüs für bestimmte Reihen der Datentabelle anwendet?",
	"Prevent clearing CSS added to node after filterByAll() in datatable filter":"Verhindere das Löschen von CSS, das nach dem FilterByAll () im Datat-Filter zum Knoten hinzugefügt wurde",
	"Can each series in a line chart have its own dataCollection?":"Kann jede Reihe in einem Liniendiagramm ihre eigene dataCollection haben?",
	"Labels in rangechart":"Labels in der Rangliste",
	"onBlur event not working for MultiSelect":"onBlur-Ereignis funktioniert nicht für MultiSelect",
	"Datatable focus on first cell":"Datatable Fokus auf erste Zelle",
	"Binding Filters to each other":"Bindefilter aneinander",
	"Error: [DOM] Found 7 elements with non-unique id":"Fehler: [DOM] 7 Elemente mit nicht eindeutiger ID gefunden",
	"Datatable editing within multiview":"Datat Bearbeitung in Multiview",
	"Dynamic load filtering doesnot work with custom request call to server":"Die dynamische Lastfilterung funktioniert nicht mit dem benutzerdefinierten Anforderungsaufruf an den Server",
	"Task":"Aufgabe",
	"Project":"Projekt",
	"User":"Benutzer",
	"Start":"Anfang",
	"Completed":"Abgeschlossen",
	"Add a new task":"Eine neue Aufgabe hinzufügen",
	"Assignee":"Beauftragter",
	"Cancel":"Stornieren",
	"Add":"Hinzufügen",
	"Click to complete/uncomplete the task":"Klicken Sie auf, um die Aufgabe abzuschließen / um wieder die Aufgabe zu öffnen",
	"Double-click to edit the task name":"Doppelklicken Sie, um den Namen der Aufgabe zu bearbeiten",
	"Double-click to change the project":"Doppelklicken Sie, um das Projekt zu ändern",
	"Double-click to assign to a different employee":"Doppelklicken Sie, um einem anderen Mitarbeiter zuzuweisen",
	"The task was created":"Die Aufgabe wurde erstellt",
	"The task was completed":"Die Aufgabe wurde abgeschlossen",
	"Click on the red clock to complete the task":"Klicke auf die rote Uhr, um die Aufgabe abzuschließen",
	"Week":"Woche",
	"tasks completed":"Aufgaben abgeschlossen",
	"Go back to the dashboard":"Geh zurück zum Dashboard",
	"Ain't it amazing?":"Ist das nicht toll?",
	"Meaning the view from your window. Even if it's too urban or too industrial to your taste, you can find curious beauty in its geometry.":"Ich meine die Aussicht von deinem Fenster aus. Auch wenn es zu städtisch oder zu industriell ist, hat seine Geometrie eine kuriose Schönheit.",
	"Components":"Komponenten",
	"Can you name all the Webix components that have been used to build the demo app?":"Können Sie alle Webix-Komponenten benennen, die zum Erstellen der Demo-App verwendet wurden?",
	"We miss you":"Wir vermissen Ihnen",
	"Been pretty busy lately, haven't you? That's great! But also do not forget about us.":"Sie waren in letzter Zeit ziemlich beschäftigt, nicht wahr? Das ist großartig! Aber vergessen Sie auch nicht über uns.",
	"Have a nice day":"Ich wünsche Ihnen einen schönen Tag!",
	"Dear client, whenever you are reading this, we wish you a merry day. May luck and success attend you.":"Lieber Kunde, wenn Sie dies lesen, wünschen wir Ihnen einen schönen Tag. Möge Glück und Erfolg Sie begleiten.",
	"Colors and Languages":"Farben und Sprachen",
	"To pick a language or the color theme for the demo app, click on the avatar in the top right corner.":"Um eine Sprache oder ein Farbthema für die Demo-App auszuwählen, klicken Sie auf den Avatar in der oberen rechten Ecke.",
	"We love you":"Wir lieben Ihnen",
	"Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.":"Lieber Kunde, wir lieben Ihnen sehr. Wenn unsere Gefühle gegenseitig sind, kontaktieren Sie uns und laden Sie Webix herunter. Dann werden wir Ihnen ewig lieben."
};